<template>
  <DialogWrapper
    hidden-header-line
    class="job-recommend-condition-dialog"
    :titleI18nKey="`${i18nPrefix}.title.aiTalentPoolRecommenderTitle`"
    :show.sync="isShow"
    :loading="isLoading"
  >
    <div class="recommendation-tip">{{ $t(`${i18nPrefix}.label.aiTalentPoolRecommenderTip`) }}</div>
    <el-divider></el-divider>
    <JobFitConditionEditor ref="jobFitCondition" is-talent-pool :jobId="jobId"></JobFitConditionEditor>
    <template #footer>
      <div class="dialog-footer">
        <el-button v-if="!onlyDisplay" class="footer-btn cancel-btn" @click="onRestBtnClick">
          <span class="label">{{ $t(`${i18nPrefix}.btn.talentRecommendation.reset`) }}</span>
        </el-button>
        <el-button v-if="!onlyDisplay" class="footer-btn save-btn" @click="onRecommendBtnClick">
          <span class="label">{{ $t(`${i18nPrefix}.btn.aiTalentPoolRecommenderBtn`) }}</span>
          <i class="btn-icon iconfont icona-ResumeSummary"></i>
        </el-button>
      </div>
    </template>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import JobFitConditionEditor from '@/components/job/editor/jobFit/jobFitConditionEditor.vue'

export default {
  components: {
    DialogWrapper,
    JobFitConditionEditor
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    jobId: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      onlyDisplay: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    isLoading: {
      get () {
        return this.loading
      },
      set (val) {
        this.$emit('update:loading', val)
      }
    }
  },
  created () {

  },
  methods: {
    async resetCondition (displayCondition, onlyDisplay) {
      while (!this.$refs.jobFitCondition) {
        await this.$nextTick()
      }
      this.onlyDisplay = onlyDisplay
      return this.$refs.jobFitCondition.setConditionData(displayCondition, onlyDisplay)
    },
    async onRecommendBtnClick () {
      if (this.onlyDisplay) {
        return
      }
      const talentCondition = await this.$refs.jobFitCondition.getConditionData()
      this.$emit('recommend', talentCondition)
    },
    onRestBtnClick () {
      if (this.onlyDisplay) {
        return
      }
      this.resetCondition()
    }
  }
}
</script>

<style lang="scss" scoped>
.job-recommend-condition-dialog {
  .recommendation-tip {
    margin-top: 20px;
    color: #606266;
    font-size: 16px;
    font-weight: 500;
    word-break: break-word;
  }
  .dialog-footer {
    display: flex;

    .save-btn {
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
      .label {
        vertical-align: middle;
      }
      .btn-icon {
        margin-left: 4px;
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .cancel-btn {
      background: #aaa;
      border-color: #aaa;
      color: #fff;
      margin-right: auto;
    }
  }
}
</style>
